<template>
  <div class="admin">
    <!-- <h1>Admin Page</h1> -->
    <div class="users-table-wrapper">
      <UserTable />
    </div>
  </div>
</template>

<script>
import AdminUserTable from '@/components/Admin/AdminUserTable';

export default {
  components: {
    UserTable: AdminUserTable
  }
};
</script>

<style lang="scss" scoped>
.users-table-wrapper {
  margin: 0 auto;
  padding: 2rem 0;
  height: calc(100% - 50px);
  width: 95vw;
  max-width: 1200px;
}
</style>
